import styled from "styled-components";

// Общие стили для профиля (заявки и клиенты)
export const ProfileContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
    position: relative;
    width: 100%;
    gap: 12px;

    @media (max-width: 768px) {
        margin-bottom: 8px;
        gap: 8px;
    }
`;

export const ProfileMain = styled.div`
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
    gap: 12px;

    @media (max-width: 768px) {
        gap: 8px;
    }
`;

export const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    gap: 6px;
`;

export const NameContainer = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 4px;
`;

export const Name = styled.div`
    display: flex;
    flex-direction: column;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    gap: 0;
    cursor: pointer;
    position: relative;
    min-height: calc(1.4em * 2); /* Резервируем две строки */

    &:hover {
        text-decoration: underline;
        color: #c1c1ff;
    }

    @media (max-width: 768px) {
        font-size: 13px;
        min-height: calc(1.4em * 2);
    }
`;

export const NameText = styled.span`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    gap: 4px;
    margin-left: auto;
`;

export const AvatarBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 36px;
        height: 36px;
    }

    img {
        display: block;
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 50%;
        object-fit: cover;
    }
`;

// Специфичные для заявок
export const StatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
`;
